/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Daily rate
 * @export
 * @interface TravelineBookingDailyRateDto
 */
export interface TravelineBookingDailyRateDto {
    /**
     * Price per night excluding taxes and fees
     * @type {number}
     * @memberof TravelineBookingDailyRateDto
     */
    priceBeforeTax?: number;
    /**
     * Date. Date format complies with ISO-8601 YYYY-MM-DD
     * @type {Date}
     * @memberof TravelineBookingDailyRateDto
     */
    date?: Date;
}

/**
 * Check if a given object implements the TravelineBookingDailyRateDto interface.
 */
export function instanceOfTravelineBookingDailyRateDto(value: object): value is TravelineBookingDailyRateDto {
    return true;
}

export function TravelineBookingDailyRateDtoFromJSON(json: any): TravelineBookingDailyRateDto {
    return TravelineBookingDailyRateDtoFromJSONTyped(json, false);
}

export function TravelineBookingDailyRateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingDailyRateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceBeforeTax': json['priceBeforeTax'] == null ? undefined : json['priceBeforeTax'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}

  export function TravelineBookingDailyRateDtoToJSON(json: any): TravelineBookingDailyRateDto {
      return TravelineBookingDailyRateDtoToJSONTyped(json, false);
  }

  export function TravelineBookingDailyRateDtoToJSONTyped(value?: TravelineBookingDailyRateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceBeforeTax': value['priceBeforeTax'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
    };
}

